import { Component, OnInit, Input } from '@angular/core';
import { ReportsService } from 'src/app/services/reports.service';
import { ViewsService } from 'src/app/services/views.service';
import { Report } from 'src/app/models/report.model';
import { DealersService } from 'src/app/services/dealers.service';
import { FormControl } from '@angular/forms';
import { startWith, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { ColumnDefinition } from 'src/app/dto/columnDefinition';

export class ViewByTimeFrame {
  Date: Date;
  count: number;
}

@Component({
  selector: 'app-views-daily-report',
  templateUrl: './views-daily-report.component.html',
  styleUrls: ['./views-daily-report.component.scss']
})
export class ViewsDailyReportComponent implements OnInit {

  constructor(private reportService: ReportsService, private viewsService: ViewsService, private dealersService: DealersService) { }

  ngOnInit(): void {
    this.reportService.getReports().subscribe(res => {
      const allOption = new Report();
      allOption.id = 0;
      allOption.name = "ALL";
      this.reports = [allOption];
      this.reports = this.reports.concat(res);
      this.getData();
    });

    this.dealerFilterControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(query => {
        return this.searchDealers(query);
      })
    )
      .subscribe(data => {
        this.dealerSearchValues = data;
      });
  }

  @Input('byUser') byUser : boolean;

  reports: Report[];
  viewsByBAC: number[] = [];
  bacs: string[] = [];
  isLoading = true;
  selectedReportId: number = 0;
  selectedReportName = "ALL";

  selectedTimeFilter = 'WTD';
  timeFilters = ['WTD', 'MTD', 'YTD'];

  selectedVendorId: string;

  getData() {
    if (this.byUser) {
      this.getReportViewsByUser()
    } else {
      this.getReportViews();
    }
  } 

  // REGION - Line Chart

  chartData: ViewByTimeFrame[];

  getReportViews() {
    this.isLoading = true;
    let timeFilter = this.selectedTimeFilter
    if (timeFilter == '') timeFilter = 'WTD'
    this.viewsService.getReportViewsByTimeFrame(this.selectedReportId, timeFilter, this.selectedVendorId, 0).subscribe((res: any[]) => {
      this.chartData = res;
      this.isLoading = false;
    })
  }

  // REGION - Table

  tableData: any[] = [];

  columns: ColumnDefinition[] = [
    { columnDef: 'rank', header: 'Rank', cell: (w: any) => `${w.rank}` },
    { columnDef: 'bac', header: 'BAC', cell: (w: any) => `${w.bac}` },
    { columnDef: 'count', header: 'Views', cell: (w: any) => `${w.count}` }
  ];

  getReportViewsByUser() {
    this.isLoading = true;
    let timeFilter = this.selectedTimeFilter
    if (timeFilter == '') timeFilter = 'WTD'
    this.viewsService.getReportViewsByTimeFrame(this.selectedReportId, timeFilter, this.selectedVendorId, 1).subscribe((res : any[]) => {
      this.tableData = [];
      for (let i = 0; i < res.length; i++) {
        this.tableData.push({
          rank: res[i].rank,
          bac: res[i].bac,
          count: res[i].count
        })
      }
      this.isLoading = false;
    })
  }

  // REGION - Filters

  filterByTime(time: string) {
    this.selectedTimeFilter = time;
    this.getData();
  }

  filterByReport(report: Report) {
    this.selectedReportId = report.id;
    this.getData();
  }

  dealerSearchValues: any;
  dealerFilterControl = new FormControl();
  dealerFilter: string;

  searchDealers(query: string) {
    return this.dealersService.search(0, 15, query);
  }

  filterByDealer(vendorId : string) {
    this.selectedVendorId = vendorId;
    this.getData();
  }

}
